import { createSlice } from '@reduxjs/toolkit';

export const notifierSlice = createSlice({
  name: 'notifier',
  initialState: {
    notifications: [],
  },
  reducers: {
    enqueueSnackbar: (state, action) => {
      const key = action.payload.options && action.payload.options.key;
      return {
        notifications: [
          ...state.notifications,
          {
            ...action.payload,
            key: key || new Date().getTime() + Math.random(),
          },
        ],
      };
    },

    closeSnackbar: (state, action) => ({
      notifications: state.notifications.map(notification =>
        action.payload.dismissAll || notification.key === action.payload.key
          ? { ...notification, dismissed: true }
          : { ...notification },
      ),
    }),
    removeSnackbar: (state, action) => ({
      notifications: state.notifications.filter(
        notification => notification.key !== action.payload,
      ),
    }),
  },
});

export const { enqueueSnackbar, closeSnackbar, removeSnackbar } =
  notifierSlice.actions;

export default notifierSlice.reducer;
